import { request, requestAuth } from "common-frontend-components";
import axios from 'axios';
import { appConfig } from "../variables/appConfig";
export function callCreateSitePhotoAsync({ path, params }) {
    return requestAuth.post(appConfig.sitePhotosUrl, { path, params })
        .then((response) => {
        response.created = new Date(response.created);
        return response;
    });
}
export function callCreateSitePhotoGroupAsync(data) {
    return requestAuth.post(`${appConfig.sitePhotosUrl}/group`, data);
}
export const callDeleteSitePhotoGroupAsync = (id) => requestAuth.delete(`${appConfig.sitePhotosUrl}/group/${id}`);
export const callDeleteSitePhotoGroupsAsync = (id) => requestAuth.delete(`${appConfig.sitePhotosUrl}/delete-groups-by-site-photo-id/${id}`);
export const callDeleteSitePhotoAsync = (id) => requestAuth.delete(`${appConfig.sitePhotosUrl}/${id}`);
export function callEditSitePhotoAsync(id, data) {
    return requestAuth.patch(`${appConfig.sitePhotosUrl}/${id}`, data)
        .then((response) => {
        response.created = new Date(response.created);
        if (response.photoLastModified)
            response.photoLastModified = new Date(response.photoLastModified);
        return response;
    });
}
export const callGetGroupsBySitePhotoAsync = (sitePhotoId) => request.get(`${appConfig.sitePhotosUrl}/groups/get-by-site-photo-id/${sitePhotoId}`);
export function callGetSitePhotoByKeyAsync(key) {
    return request.post(`${appConfig.sitePhotosUrl}/get-by-key`, { key })
        .then((response) => {
        response.created = new Date(response.created);
        if (response.photoLastModified)
            response.photoLastModified = new Date(response.photoLastModified);
        return response;
    });
}
export function callGetSitePhotoByPathAsync(path) {
    return request.post(`${appConfig.sitePhotosUrl}/get-by-path`, { path })
        .then((response) => {
        response.created = new Date(response.created);
        if (response.photoLastModified)
            response.photoLastModified = new Date(response.photoLastModified);
        return response;
    });
}
export const callGetSitePhotoGroupAsync = (groupId) => request.get(`${appConfig.sitePhotosUrl}/groups/${groupId}`);
export const callGetSitePhotoGroupsByNameAsync = (groupName) => request.post(`${appConfig.sitePhotosUrl}/groups/get-by-name/${groupName}`);
export const callGetSitePhotoGroupsAsync = () => request.get(`${appConfig.sitePhotosUrl}/groups`);
export function callGetSitePhotosByGroupAsync(group) {
    return request.post(`${appConfig.sitePhotosUrl}/get-by-group`, { group })
        .then((response) => {
        response.forEach(i => {
            i.created = new Date(i.created);
            if (i.photoLastModified)
                i.photoLastModified = new Date(i.photoLastModified);
        });
        return response;
    });
}
export function callGetSitePhotosAsync() {
    return request.get(`${appConfig.sitePhotosUrl}`)
        .then((response) => {
        response.forEach(i => {
            i.created = new Date(i.created);
            if (i.photoLastModified)
                i.photoLastModified = new Date(i.photoLastModified);
        });
        return response;
    });
}
export const callInitSitePhotoDeleteAsync = (key) => requestAuth.post(`${appConfig.sitePhotosUrl}/delete-by-key`, { key });
export async function callInitSitePhotoUploadAsync(file, metadata) {
    const initiateResult = await requestAuth.post(`${appConfig.sitePhotosUrl}/initiate-upload`, metadata);
    await axios.put(initiateResult.s3PutObjectUrl, file, {
        headers: {
            'Content-Type': metadata.contentType,
        },
    });
    return initiateResult;
}
//# sourceMappingURL=sitePhotos.js.map